





















































import { Vue, Component } from 'vue-property-decorator';
import { uuid } from '@/util/uuid';

@Component({
  components: {},
})
export default class LaunchDraw extends Vue {
  private visible = false; // drawer是否显示
  private title: any = ''; // drawer标题

  activeName = 'second'; //默认选项卡激活项
  sponsorType = '1'; //单选按钮
  whoSubmit = ''; //输入框

  handleAll = ''; //全选绑定值
  newArr: any = []; //每一个选中组成的数组
  nodeConfig: any;
  uuid: any;

  //表格主体数据
  private tableData: any = [];

  private data: any = {};

  private async showDrawer(form: any, nodeConfig: any) {
    this.uuid = uuid();
    this.nodeConfig = nodeConfig;
    this.handleAll = '';
    const arr: any = [];
    form.formData &&
      form.formData.forEach((item: any) => {
        let value: any = '';
        if (nodeConfig.formControlAuth) {
          for (const key in nodeConfig.formControlAuth) {
            if (key === item.form.id) {
              value = nodeConfig.formControlAuth[key];
            }
          }
        }
        arr.push({
          id: item.form.id,
          formField: item.form.label,
          handle: value || 'hide',
          name: item.form.id + this.uuid,
        });
      });
    this.tableData = arr;
    this.visible = true;
    this.title = '发起人';

    // this.tableData.forEach((item: any) => (item.handle = item.handle || 'hide'));
  }
  private handleClose() {
    this.visible = false;
  }

  private handleClick(tab: any, event: any) {}

  /**
   * desc 实现全选
   * */
  allChange() {
    this.tableData.forEach((item: any) => (item.handle = this.handleAll));
  }
  /**
   * desc 选中每一个实现全选
   * params1 e event事件源对象
   * */
  oneChange(e: any) {
    this.newArr = [];
    this.tableData.forEach((item: any) => {
      this.newArr.push(item.handle);
    });
    if (this.newArr.every((item: any) => item === e.target.dataset.type)) {
      this.handleAll = e.target.dataset.type;
    } else {
      this.handleAll = '';
    }
  }

  saveData() {
    // this.$emit('setData', this.data);
    console.log(this.tableData);
    const obj: any = {};
    this.tableData.forEach((item: any) => {
      if (item.handle !== '') {
        obj[item.id] = item.handle;
      }
    });
    console.log(obj);
    this.nodeConfig.formControlAuth = obj;
    this.$emit('setData', this.nodeConfig);
    this.visible = false;
  }
}
